import { invoke, until } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { LoginStatus } from '@/common/const';
import { useLoginStore } from '@/store';

/**
 * 在登录态 ready 后执行函数，确保执行的函数一定能获取到登录态
 */
export const onLoginReady = (fn: Function) => {
  const { loginStatus } = storeToRefs(useLoginStore());
  invoke(async () => {
    await until(loginStatus).toMatch(v => v !== LoginStatus.UNKNOWN);
    fn();
  });
};
